module.exports = "/assets/data/377382fb9a0e3b4fdda394f1e4a1572f-CF83.data.json";